import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-section-values',
    templateUrl: './section-values.component.html',
    styleUrls: ['./section-values.component.scss'],
    standalone: false
})
export class SectionValuesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
